<template>
  <div class="banner_community" v-if="bannerList.length > 0 && isKeep">
    <mySwiper
      ref="banner_community_swiper"
      :loop="bannerList.length > 1 ? true : false"
      :slidesNum="1"
      :cssWidthAndHeight="true"
      :autoplay="bannerList.length > 1 ? true : false"
      :autoplayNumber="3000"
      :paginationFlag="bannerList.length > 1 ? true : false"
      :swipeid="'banner_community_swiper'"
      @slideChange="slideChange"
    >
      <div
        class="swiper-slide"
        slot="swiper-con"
        v-for="(banner, index) in bannerList"
        :key="banner.id"
        :style="{ backgroundImage: 'url(' + banner.imgUrl + ')' }"
        @click.stop="toBannerLink(banner, index)"
      >
        <!-- 安卓手机，并且url为外链 -->
        <a
          v-if="/(http|https):\/\/([\w.]+\/?)\S*/.test(banner.jumpUrl)"
          @click="goBanner(banner, index)"
        ></a>
      </div>
    </mySwiper>
    <template v-for="(banner, index) in bannerList">
      <div
        class="hometagWrap"
        v-if="!/(http|https):\/\/([\w.]+\/?)\S*/.test(banner.jumpUrl)"
        :key="banner.imgUrl"
        v-show="activeIndex == index"
      >
        <openWxTag
          :id="'communityBanner' + banner.id"
          :path="banner.jumpUrl"
          btnStyle="width:100%;height:100px"
          @sensorsFn="toBannerLink(banner, index)"
        ></openWxTag>
      </div>
    </template>
  </div>
</template>

<script>
import mySwiper from "@/components/common/mySwiper/mySwiper.vue"; //轮播图
import { goToMini, TestUserAgent } from "@/assets/js/common.js";
import openWxTag from "@/components/common/openWeappTag/index.vue";
import { BuiedPointClick_Fn, Exposurer_Fn } from "@/assets/js/BuriedPointEvent";
// import { home_banner_export } from "@/assets/js/Exposure";
export default {
  name: "communityBanner",
  data() {
    return {
      bannerList: [], //banner列表
      UserInfo: null,
      unionid: "",
      isSystem: "",
      activeIndex: 0,
      sensorsIndex: 0,
      isKeep: false,
    };
  },
  components: { mySwiper, openWxTag },
  activated() {
    this.isKeep = true;
  },
  deactivated() {
    this.isKeep = false;
  },
  mounted() {
    this.getBannerList();
    this.isSystem = TestUserAgent().isios;
  },
  methods: {
    goToMini,
    slideChange(index) {
      this.sensorsIndex = this.sensorsIndex + 1;
      this.activeIndex = index == this.bannerList.length + 1 ? 0 : index - 1;
      if (this.sensorsIndex <= this.bannerList.length) {
        sensors.track("xmhh5CommunityExpo", {
          xmhh5_Community_Banner_Expo: this.bannerList[this.activeIndex].title,
        });
      }
    },
    // 获取banner列表
    getBannerList() {
      this.$http.post(
        "/content/banner/query",
        {},
        { columnId: 12 },
        (res) => {
          if (res.code === 200) {
            this.isKeep = true;
            this.bannerList = res.data || [];
          }
        },
        (err) => {
          console.log(err);
        },
        "lucky"
      );
    },
    // banner点击
    toBannerLink(item, index) {
      BuiedPointClick_Fn("xmhh5CommunityBannerClick", {
        xmhh5_Community_Banner_title: item.title,
        xmhh5_Community_Banner_position: index + 1,
      });
    },
    goBanner(banner, index) {
      setTimeout(() => {
        location.href = banner.jumpUrl;
      }, 3000);
    },
  },
};
</script>

<style lang="less" scoped>
.banner_community {
  position: relative;

  /deep/.mySwiper {
    .swiper-container {
      height: 100px;
      overflow: hidden !important;
      padding-bottom: 0 !important;

      .swiper-wrapper {
        .swiper-slide {
          border-radius: 6px;
          overflow: hidden;
          background-size: 100% auto;
          background-position: center center;
          height: 100px;
          a {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
      }

      //
      .swiper-pagination-clickable {
        position: relative;
        text-align: center;
        width: 100%;
        font-size: 0;
        transition: opacity 0.3s;
        transform: translateZ(0);
        z-index: 10;

        .swiper-pagination-bullet {
          width: 5px;
          height: 5px;
          // background: #ffffff;
          border-radius: 50%;
          opacity: 0.5;
          margin: 0 3px;

          &.swiper-pagination-bullet-active {
            border-radius: 6px;
            width: 10px;
            opacity: 1;
          }
        }
      }
    }
  }

  .hometagWrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100px;
    z-index: 999;

    a {
      display: block;
      width: 100%;
      height: 100px;
    }
  }
}
</style>
